import _ from 'lodash'
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import lang from 'lang'
import { httpRequest } from 'services/saga'
import { getApiUrl } from 'services/selectors'
import { validateField, validateFields } from 'common/validator'
import { requests } from 'common/requests'

import {
  addFieldError,
  clearFieldError,
  FORGOT_PASSWORD_REQUEST,
  forgotPasswordFailure,
  forgotPasswordSuccess,
  VALIDATE_FORGOT_PASSWORD_FIELD,
} from './actions'

function* forgotPasswordSaga({
  payload,
}: {
  payload: { email: { value: string; validations?: string } }
}): Generator<unknown, void, unknown> {
  const errors = validateFields(
    payload as unknown as Parameters<typeof validateFields>[0],
  ) as Record<string, string | undefined>

  if (_.isEmpty(errors)) {
    const apiURL = (yield select(getApiUrl)) as string
    try {
      yield call(httpRequest, {
        req: requests.post,
        url: `${apiURL}/rpc/forgot_password`,
        headers: { Prefer: 'params=single-object' },
        data: _.mapValues(payload, 'value'),
      })
      yield put(forgotPasswordSuccess())
    } catch (error: unknown) {
      yield put(
        forgotPasswordFailure({
          base: _.get(error, 'response.data.message', lang.unhandledServerError) as string,
        }),
      )
    }
  } else {
    yield put(forgotPasswordFailure(errors as Record<string, string>))
  }
}

export function* validateFieldSaga({
  payload: { field, value, validations },
}: {
  payload: { field: string; value: string; validations?: string }
}): Generator<unknown, void, unknown> {
  const error = validateField({ field, value, fieldValidations: validations ?? '' })
  const errorStr = typeof error === 'string' ? error : error != null ? String(error) : undefined
  if (errorStr) {
    yield put(addFieldError({ field, error: errorStr }))
  } else {
    yield put(clearFieldError({ field }))
  }
}

export default function* saga(): Generator<unknown, void, unknown> {
  yield all([
    // @ts-expect-error redux-saga string action type
    takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordSaga),
    // @ts-expect-error redux-saga string action type
    takeEvery(VALIDATE_FORGOT_PASSWORD_FIELD, validateFieldSaga),
  ])
}
